import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './MessageCardList.css';

const formatDateTime = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd} ${hh}:${min}`;
};

const MessageCard = ({ row }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`message-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="message-card-main">
        <div className="message-card-name">{row.name || row.phone || '—'}</div>
        <div className="message-card-phone">{row.phone || '—'}</div>
        <div className="message-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="message-card-secondary">
          <span>{formatDateTime(row.date)}</span>
          {row.direction && (
            <span className={`message-card-direction ${row.direction}`}>{row.direction}</span>
          )}
          {row.message_type && (
            <span className="message-card-type">{row.message_type}</span>
          )}
        </div>
      </div>

      {expanded && (
        <div className="message-card-detail" onClick={e => e.stopPropagation()}>
          <div className="message-card-detail-row">
            <span>{t('phone')}</span><span>{row.phone || '—'}</span>
          </div>
          <div className="message-card-detail-row">
            <span>{t('date')}</span><span>{formatDateTime(row.date)}</span>
          </div>
          <div className="message-card-detail-row">
            <span>{t('message_type')}</span><span>{row.message_type || '—'}</span>
          </div>
          {row.source && (
            <div className="message-card-detail-row">
              <span>{t('source')}</span><span>{row.source}</span>
            </div>
          )}
          {row.direction && (
            <div className="message-card-detail-row">
              <span>{t('direction')}</span><span>{row.direction}</span>
            </div>
          )}
          {row.raw_message && (
            <div className="message-card-raw">
              <div className="message-card-raw-label">{t('raw_message')}</div>
              <div className="message-card-raw-text">{row.raw_message}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const MessageCardList = ({ data }) => {
  return (
    <div className="message-card-list">
      {data && data.map((row, i) => (
        <MessageCard key={row._id || i} row={row} />
      ))}
      {(!data || data.length === 0) && (
        <div className="message-card-empty">—</div>
      )}
    </div>
  );
};

export default MessageCardList;
